/**
 * SidebarIcon/index.tsx
 * desc: navigation sidebar icon (collapse / expand toggle of the v2 sidebar)
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */

import IconButton, { type IconProps } from '../IconButton/typed';
import { translate } from '../../../utilities/localization';


const SidebarIcon = ({ tooltip, ...props }: IconProps) => (
    <IconButton
        baseClassName="sidebar icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.sidebar.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 20 16" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M2 0h16a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm6 2v12h10V2H8z"/></svg>
    </IconButton>
);


export default SidebarIcon;
